import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NavService } from '../../../../services/nav.service';

@Component({
  selector: 'app-languages',
  templateUrl: './languages.component.html',
  styleUrls: ['./languages.component.scss']
})
export class LanguagesComponent implements OnInit {

  public language: boolean = false;

  public languages: any[] = [{
    language: 'English',
    code: 'en',
    type: 'US',
    icon: 'us'
  },
  {
    language: 'Arabic',
    code: 'ar',
    type: 'AR',
    icon: 'ar'
  },
]

  public selectedLanguage: any =  {
    language: 'Arabic',
    code: 'ar',
    type: 'AR',
    icon: 'ar'
  }

  constructor(public navServices: NavService, private translate: TranslateService) { }
  // 
    ngOnInit() {
        this.translate.use("ar");
  }

  changeLanguage(lang) {
      this.translate.use(lang.code);
    this.selectedLanguage = lang;
    
  }

}
